module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-content-chevy.18b69244.jpg";